import templateUrl from 'servicestack/tags/tag-manager.htm'
import TagPrompt from 'servicestack/tags/tag-prompt'
import config from 'servicestack/tags/_config'
import labels from 'servicestack/tags/_labels'
import AutoQuery from 'servicestack/auto-query/auto-query'
import modals from 'webmodals/modals'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'

class controller {
    constructor($scope) {
        const $ctrl = this;
        basicController($ctrl);
        let $rootScope = resolve('$rootScope');
        $ctrl.config = config;
        $ctrl.labels = labels;
        $ctrl.query = new AutoQuery({
            url: 'QueryTagConfigs.json',
            filters: [
                { groupBy: 'Shard', title: labels.shard },
                { groupBy: 'Type', title: labels.type },
            ],
            hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
            orderBy: 'TagKind',
            sortOptions: {
                'Shard': 'Area: A to Z',
                '-Shard': 'Area: Z to A',
                'TagKind': 'Name: A to Z',
                '-TagKind': 'Name: Z to A',
                'Position': 'Position: A to Z',
                '-Position': 'Position: Z to A',
            },
            autoLoad: true,
            pageSize: 12
        });
    }
    $onInit() {
        const $ctrl = this;
    }

    $delete(tagConfig) {
        const $ctrl = this;
        return modals.confirm("Are you sure?", "Delete Tag").result.then(function () {
            $ctrl.query.bus.send('DeleteTagConfig.json', tagConfig).then(function (response) {
                $ctrl.query.load(true);
            });
        });
    }
    create() {
        const $ctrl = this;
        TagPrompt.open({ request: { shard: $ctrl.query.criteria.shard } }).then(() => $ctrl.query.load(true));
    }
    view(tagConfig) {
        const $ctrl = this;
        TagPrompt.open({ request: tagConfig }).then(() => $ctrl.query.load(true));
    }
}

export default {
    bindings: {
        shards: '<?'
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};